var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElipseForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 629,
    viewBox: "0 0 629 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.221,
    cy: 314.221,
    r: 313.824,
    stroke: "#EEEEEE",
    strokeOpacity: 0.07,
    strokeWidth: 0.793486
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.221,
    cy: 314.221,
    r: 259.073,
    stroke: "#EEEEEE",
    strokeOpacity: 0.1,
    strokeWidth: 0.793486
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.221,
    cy: 314.221,
    r: 197.975,
    stroke: "#EEEEEE",
    strokeOpacity: 0.2,
    strokeWidth: 0.793486
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipseForm);
export default __webpack_public_path__ + "static/media/Elipse-form.20904cb54497ea6f29e543069b6f0ac4.svg";
export { ForwardRef as ReactComponent };